export function isCancelledInvoiceStatus(status: string) {
  return status === "storniert" || status === "abgeschrieben";
}

export function effectiveInvoiceTotal(
  invoices: Array<{ total_cent: number; status: string }>,
) {
  return invoices
    .filter((invoice) => !isCancelledInvoiceStatus(invoice.status))
    .reduce((sum, invoice) => sum + Number(invoice.total_cent || 0), 0);
}

export function cancelledInvoiceTotal(
  invoices: Array<{ total_cent: number; status: string }>,
) {
  return invoices
    .filter((invoice) => isCancelledInvoiceStatus(invoice.status))
    .reduce((sum, invoice) => sum + Number(invoice.total_cent || 0), 0);
}
